import { RootState } from "@/app/stores"
import { createSelector } from "@reduxjs/toolkit"

const baseSelector = createSelector(
    (state: RootState) => state,
    state => state.partnerDiscounts
)

export const selectPartnerDiscounts = createSelector(
    baseSelector,
    (state) => state.discounts
)

export const selectPartnerDiscountsLoading = createSelector(
    baseSelector,
    (state) => state.isFirstLoad
)

export const selectPartnerDiscountsFirstLoad = createSelector(
    baseSelector,
    (state) => state.isFirstLoad
)

export const selectPartnerDiscountsError = createSelector(
    baseSelector,
    (state) => state.error
)

export const selectCurrentPartner = createSelector(
    baseSelector,
    (state) => state.selectedPartner
)

export const selectCurrentPage = createSelector(
    baseSelector,
    (state) => state.page
)

export const selectTotalPages = createSelector(
    baseSelector,
    (state) => state.page
)